module.exports = __webpack_public_path__ + "img/img.24949ec5.png";